import * as React from 'react';
import classNames from 'classnames';
import moment from 'moment';

import '@/lib/string';
import { AccountLink } from '@/lib/navigation';
import type { EventElementProps } from './event-element-props.interface';
import { MmsContent } from './MmsContent';

export interface MmsMessageProps extends EventElementProps {
  ticket: string;
  eventId: string;
}

export const MmsMessage = ({ data, ticket, eventId }: MmsMessageProps) => (
  <div
    id={`MmsMessage-${data.id}`}
    className={`message-box ${data.direction}`}
    data-status={data.status}
    data-direction={data.direction}
    title={`${data.segments} mms ${data.segments === 1 ? 'segment' : 'segments'}`}
  >
    <div className={data.direction === 'in' ? 'inbound-message' : 'outbound-message'}>
      {data.contents && data.contents.length > 0 && (
        <div className="media">
          {data.contents.map(({ id, url, content_type, dimensions }) => (
            <MmsContent
              key={id}
              ticket={ticket}
              eventId={eventId}
              url={url}
              mime={content_type}
              dimensions={dimensions}
            />
          ))}
        </div>
      )}
      <div
        className={classNames('message-text', { 'large-text': data.pure_emoji_message })}
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={data.message_html.toReactHtml({ linkify: true })}
      />
    </div>
    <div className={`chat-timestamp stamp-${data.direction}`}>
      <span className="chat-timestamp-sender">
        {data.sender_tag}
      </span>
      {data.broadcast_id && (
        <AccountLink path={`broadcasts/${data.broadcast_id}`}>
          <span className="chat-timestamp-origin account-link">
            {` - via Broadcast ${data.broadcast_name?.substring(0, 30) ?? ''}`}
          </span>
        </AccountLink>
      )}
      {data.segments > 1 && (
        <span className="chat-timestamp-segments">
          {` - ${data.segments} mms segments`}
        </span>
      )}
      {data.sent_at && (
        <span className="chat-timestamp-timestamp">
          {` - ${moment(data.sent_at * 1000).format('L [AT] LT')}`}
        </span>
      )}
      <span className={classNames('chat-read-receipt', data.read_receipt)} />
      <span className="chat-timestamp-error">
        {data.sanitized_error_text}
      </span>
    </div>
  </div>
);
